import React from "react"

import RatingOptionPill from "../option-pill"

export default function FieldRating_MultiselectValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-field-form-editable dropdown-form fl-wrap min-h-36", props.className)} onClick={props.onClick}>
                {_.map(props.options, option => <RatingOptionPill key={option.value} scale={props.scale} option={option} onDelete={props.onDelete}/>)}
            </div>
            {props.children}
        </React.Fragment>
    )
}